import React, { useEffect, useState } from "react";
import Carousel from "../Carousel";
import { generateDates } from "../../utils/dateUtils";
import "./styles.css";

const DateCarousel = ({ qntdItems, onSelectDate, selectedMonth }) => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [allDays, setAllDays] = useState([]);

  useEffect(() => {
    const dates = generateDates(30, selectedMonth); // Usa o mês selecionado para gerar as datas
    setAllDays(dates);
    setSelectedDay(null); // Desmarca qualquer dia selecionado
  }, [selectedMonth]);

  const handleDayClick = (day) => {
    setSelectedDay(day.date);
    if (onSelectDate) {
      onSelectDate(day.date);
    }
  };

  const renderDay = (day) => (
    <div className="days-container" key={day.date}>
      <button
        onClick={() => handleDayClick(day)}
        className={`day-button ${selectedDay === day.date ? "selected" : ""}`}
      >
        <span className="day-number">{day.day}</span>
        <span className="day-text">{day.weekDay}</span>
      </button>
    </div>
  );

  return (
    <Carousel
      items={allDays} 
      renderItem={renderDay} 
      qntdItems={qntdItems}
    />
  );
};

export default DateCarousel;
